// Public Blog API service for frontend

import { backendBaseUrl } from "../config/api";

const API_BASE_URL = backendBaseUrl();

/**
 * Fetch all published blogs with pagination
 */
export async function getAllBlogs(page = 1, limit = 9) {
  const response = await fetch(
    `${API_BASE_URL}/get-blogs.php?page=${page}&limit=${limit}`
  );

  const contentType = response.headers.get("content-type") || "";

  if (!contentType.includes("application/json")) {
    throw new Error("Backend did not return JSON.");
  }

  const data = await response.json();

  if (!response.ok || data.success === false) {
    throw new Error(data.message || "Failed to fetch blogs.");
  }

  return data;
}

/**
 * Fetch single blog by slug
 */
export async function getBlogBySlug(slug) {
  const response = await fetch(
    `${API_BASE_URL}/get-blog-detail.php?slug=${encodeURIComponent(slug)}`
  );

  const contentType = response.headers.get("content-type") || "";

  if (!contentType.includes("application/json")) {
    throw new Error("Backend did not return JSON.");
  }

  const data = await response.json();

  if (!response.ok || data.success === false) {
    throw new Error(data.message || "Blog not found.");
  }

  return data;
}